import { render, staticRenderFns } from "./FormDonHang.vue?vue&type=template&id=0a8172c0&scoped=true&"
import script from "./FormDonHang.vue?vue&type=script&lang=js&"
export * from "./FormDonHang.vue?vue&type=script&lang=js&"
import style0 from "./FormDonHang.vue?vue&type=style&index=0&id=0a8172c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8172c0",
  null
  
)

export default component.exports